import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';
import type { ReactElement } from 'react';
import { cn } from '../util/classes.ts';

export type SeparatorProps = SeparatorPrimitive.Props;

/** A hairline between items: full width when horizontal, full height when vertical. */
export function Separator({ className, orientation = 'horizontal', ...props }: SeparatorProps): ReactElement {
    return (
        <SeparatorPrimitive
            data-slot="separator"
            orientation={orientation}
            className={cn(
                'shrink-0 bg-line-weak',
                'data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full',
                'data-[orientation=vertical]:w-px data-[orientation=vertical]:self-stretch',
                className,
            )}
            {...props}
        />
    );
}
